import React, { useEffect } from "react";
import { Toast } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import styled from "styled-components";
import {
	resetNotificationPage,
	getAllNotifications,
	getCountUnreadNotifications,
} from "../../store/actions/notificationAction";
import { useDispatch } from "react-redux";
import { initBasket } from "../../store/actions/cartAction";

const NotificationToast = (props) => {
	const dispatch = useDispatch();
	const { showNotification, setShowNotification, notification } = props;
	useEffect(() => {
		if (localStorage.getItem("admin")) return;
		if (showNotification) {
			getAllNotifications(
				{
					page: 1,
					limit: 10,
				},
				dispatch
			);
			getCountUnreadNotifications(dispatch);
			resetNotificationPage(dispatch);
		}
	}, [showNotification]);

	const handleClickNotificationToast = () => {
		if (
			[
				"general",
				"campaign",
				"walletUpdate",
				"normalBasket",
				"expressBasket",
			].includes(notification?.type)
		) {
			if (notification?.data?.generalData?.type === 8) {
				initBasket("express", dispatch);
				localStorage.setItem("expressMode", true);
			}
			window.location.href = `/notification/${notification?.id}`;
		} else if (
			[
				"orderPlaced",
				"orderProcessing",
				"orderDelivering",
				"orderArrived",
				"orderDelivered",
				"orderCanceled",
				"updateSlot",
			].includes(notification?.type)
		) {
			if (notification.data.express) {
				initBasket("express", dispatch);
				localStorage.setItem("expressMode", true);
			}
			window.location.href = `/all-orders`;
			localStorage.setItem("notificationID", notification?.order_id);
		}
	};

	return (
		<ToastContainer>
			<Toast
				onClose={() => {
					setShowNotification(false);
				}}
				show={showNotification}
				delay={10000}
				autohide
				animation
			>
				<Toast.Header
					style={{
						color: "#fff",
						backgroundColor: "#9cc54b",
					}}
				>
					<img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
					<div
						className="mr-auto w-100"
						style={{ cursor: "pointer" }}
						onClick={handleClickNotificationToast}
						dangerouslySetInnerHTML={{ __html: notification.title }}
					/>
					{/* <small>Just Now</small> */}
				</Toast.Header>
				<Toast.Body
					style={{ cursor: "pointer" }}
					onClick={handleClickNotificationToast}
				>
					<div dangerouslySetInnerHTML={{ __html: notification.body }} />
				</Toast.Body>
			</Toast>
		</ToastContainer>
	);
};

const ToastContainer = styled.div`
	position: fixed;
	z-index: 99999;
	top: 10px;
	right: 10px;
	.toast {
		width: 350px;
		position: relative;
		z-index: 99999;
		// top: 10px;
		right: -360px;
		transition: all 0.3s ease-in-out;
	}
	.toast.show {
		right: 10px;
	}
	.toast-body div {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

export default NotificationToast;
